import type { CreateWooCommerceOrderRequest } from './types';

export const WOOCOMMERCE_QUERY_KEYS = {
  default: () => ['woocommerce'] as const,
  createOrder: (params?: CreateWooCommerceOrderRequest) =>
    [...WOOCOMMERCE_QUERY_KEYS.default(), 'createOrder', params] as const,
};
